import React from 'react';
import ApplyFormRetail from '../../components/ApplyFormRetail';

export default function PageRetailers() {

  document.title = `Asterism for Booksellers | Asterism Books`;
  document.querySelector('meta[name="description"]').setAttribute('content', `If you're a bookseller, Asterism would love to work with you! Read about our terms and conditions and apply for an account.`);


  return (
    <div>
      <h1 className='page-header'>For Booksellers</h1>
      <div className='flex-layout flexColMobile'>
        <div className='flex-four pageContent'>
          Hello, booksellers! We'd love to work with you. Asterism's ethos and business model is built around a more sustainable model for both independent publishers and booksellers. We pride ourselves on fostering strong, direct relationships with our bookselling partners, and avoiding large online marketplaces where books are sold at larger markdowns. If you'd like to join, read on!
          <h2>Wholesale Terms </h2>
          <p>Asterism Books works primarily with <strong>independent booksellers</strong> and <strong>college bookstores</strong>. We are owned and operated by small presses, for small presses, and we prioritize direct relationships with independent booksellers. We aim to offer fair terms to independent publishers while making sure that, whenever possible, the best place to buy an Asterism title is your bookstore.</p>
          <p>If you are not an independent or college bookstore but would like us to consider working with you, please get in touch at info@asterismbooks.com.</p>
          <h3>Discounts, Shipping, & Payment</h3>
          <p>Each Asterism publisher sets their own wholesale discount. We encourage our presses to offer at least 40% off trade titles.</p>
          <ul>
            <li>Prepaid orders receive an additional 8% discount off of the wholesale price, which generally covers freight.</li>
            <li>Invoices are due within 30 days.</li>
            <li>No minimum order required.</li>
            <li>The customer pays freight.</li>
          </ul>
          <h3>Returns</h3>
          <p>Asterism titles are non-returnable, except in the following cases:</p>
          <ul>
            <li>Damaged books: We will replace damaged books or issue credit. To request credit or a replacement for a damaged book, please get in touch <a href='https://asterismbooks.com/customer-support'>here</a>.</li>
            <li>Author events: Books ordered specifically for an author event may be returned for credit within 30 days of the event.</li>
            <li>College course materials: Books ordered by college bookstores for course use may be returned for credit within 90 days.</li>
          </ul>
          <h3>Return Conditions</h3>
          <p>All returns are <strong>eligible</strong> for credit only. Credit can only be applied to future <strong>non-event</strong> orders.</p>
          <p>Returned books must arrive at Asterism in as-new, sellable condition within 30 days of the event date. We cannot issue credit for books that are damaged, signed, stickered, or otherwise marked.</p>
          <h3>For author-event orders:</h3>
          <ul>
            <li>You must indicate at checkout that the order is specifically for an author event and include the event date.</li>
            <li>Event invoices are due 30 days after the event date.</li>
          </ul>
          <h3>Apply for a Wholesale Account</h3>
          <p>Ready to order? Fill out the application on this page and we'll get back to you.</p>
        </div>
        <div className='flex-two'>
          <ApplyFormRetail />
        </div>
      </div>
    </div>
  )
}
